export default {
    namespaced: true,
    state: () => ({
        events: [
            {
                name: "Meeting",
                start: new Date("Fri Jan 15 2021 10:30:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Fri Jan 15 2021 12:30:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: " 1",
                process: " 1.3",
            }
            , {
                name: "Meeting",
                start: new Date("Sat Jan 16 2021 08:00:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Sat Jan 16 2021 09:00:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: " 1",
                process: " 1.3",
            },
            {
                name: "Meeting",
                start: new Date("Mon Jan 18 2021 13:30:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Mon Jan 18 2021 14:30:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: " 1",
                process: " 1.3",
            },
            {
                name: "Meeting",
                start: new Date("Fri Jan 22 2021 14:00:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Fri Jan 22 2021 16:00:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: " 1",
                process: " 1.3",
            },
            {
                name: "Meeting",
                start: new Date("Thu Feb 04 2021 14:00:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Thu Feb 04 2021 16:00:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.2",
            },
            {
                name: "Meeting",
                start: new Date("Thu Wed 10 2021 08:45:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Thu Wed 10 2021 10:45:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.2",
            },
            {
                name: "Meeting",
                start: new Date("Mon Feb 15 2021 12:15:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Mon Feb 15 2021 13:15:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.2",
            },
            {
                name: "Meeting",
                start: new Date("Sat Feb 20 2021 10:00:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Sat Feb 20 2021 11:00:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.2",
            },
            {
                name: "Meeting",
                start: new Date("Thu Feb 25 2021 08:30:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Thu Feb 25 2021 10:30:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.4",
            },
            {
                name: "Meeting",
                start: new Date("Sat Feb 27 2021 08:15:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Sat Feb 27 2021 10:15:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.4",
            },
            {
                name: "Meeting",
                start: new Date("Mon Mar 01 2021 08:15:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Mon Mar 01 2021 09:15:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.4",
            },
            {
                name: "Meeting",
                start: new Date("Thu Mar 04 2021 10:00:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Thu Mar 04 2021 12:00:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.6",
            },
            {
                name: "Meeting",
                start: new Date("Tue Mar 09 2021 12:45:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Tue Mar 09 2021 13:45:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.6",
            },
            {
                name: "Meeting",
                start: new Date("Sat Mar 13 2021 14:45:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Sat Mar 13 2021 16:45:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.8",
            },
            {
                name: "Meeting",
                start: new Date("Wed Mar 17 2021 14:45:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Wed Mar 17 2021 15:45:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.8",
            },
            {
                name: "Meeting",
                start: new Date("Sat Mar 20 2021 08:45:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Sat Mar 20 2021 09:45:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.8",
            },
            {
                name: "Meeting",
                start: new Date("Mon Mar 22 2021 09:45:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Mon Mar 22 2021 11:45:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "2",
                process: "2.10",
            },
            {
                name: "Meeting",
                start: new Date("Wed Apr 07 2021 08:00:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Wed Apr 07 2021 12:00:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "4",
                process: "4.2",
            },
            {
                name: "Meeting",
                start: new Date("Thu Apr 15 2021 10:45:00 GMT-0500 (Colombia Standard Time)"),
                end: new Date("Thu Apr 15 2021 11:45:00 GMT-0500 (Colombia Standard Time)"),
                consultant: "Martín Essenfeld",
                phase: "4",
                process: "4.2",
            }
        ]
    }),
    mutations: {
        mtaAddEvent(state,value){
            state.events.push(value)
        },
        mtaRemoveEvent(state,value){
            state.events = state.events.filter(item => item.start !== value)
        }
    },
    actions: {

    },
    getters: {
        getEvents:state => {
            return state.events
        }
    }

}